import { Injectable } from '@angular/core';
import { API_CONFIG, BaseCrudService } from '@nebula-shared/data-access';

import { CountryModal } from '../../domain/paises-modal.model';

@Injectable({ providedIn: 'root' })
export class CountryService extends BaseCrudService<CountryModal> {
  constructor() {
    super();
    const config = API_CONFIG.masters;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.paises}`);
  }

  /**
   * Ruta del page-response de paises, la que consulta la ventana de busqueda de maestros; el
   * servidor pagina, busca y ordena.
   *
   * @returns la ruta completa del page-response de paises
   */
  get rutaDePageResponse(): string {
    return `${this.baseUrl}/page-response`;
  }
}
